
<template>

<el-tabs v-model="activeName" type="card">
    <el-tab-pane label="任务奖励" name="first" :lazy="true">
        <car-coin-configure></car-coin-configure>
    </el-tab-pane>
    <el-tab-pane label="视频配置" name="second">
        <plus-configure></plus-configure>
    </el-tab-pane>
    <el-tab-pane label="同步更新" name="three">
      <el-button @click="syncSpCar()">同步车源信息</el-button>
    </el-tab-pane>
</el-tabs>

</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import CarCoinConfigure from './CarCoinConfigure'
import PlusConfigure from './PlusConfigure'
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name: 'tab-index',
  extends: BasicPager,
  components: {
    CarCoinConfigure,
    PlusConfigure
  },
  data () {
    return {
      activeName: 'first'
    }
  },
  methods: {
    syncSpCar: function () {
      let listener = {
        success: function () {
          alert('更新成功')
        }
      }
      BasicModel.get(this, 'main/syncSpCar.action', null, listener)
    }
  }
}

</script>
